import {
  createUserDataLabel,
  getMarbleContent,
  UserMarble,
} from "@hoylu/client-common";
import React from "react";
import { Tooltip } from "react-tooltip";
import type { ProjectUsersResponse } from "../state/workspaces/types";
import Styles from "./CollaboratorMarble.module.css";
import { UserDetail } from "./UserDetail";

interface CollaboratorMarbleProps {
  collaborator: ProjectUsersResponse;
}

export const CollaboratorMarble = ({
  collaborator,
}: CollaboratorMarbleProps) => {
  const firstAndLastName = [
    collaborator.firstName,
    collaborator.lastName,
  ].filter(Boolean);

  const marbleContent = getMarbleContent(
    ...(firstAndLastName.length ? firstAndLastName : [collaborator.email]),
  );

  const title = !firstAndLastName.length
    ? createUserDataLabel(collaborator)
    : "";

  const tooltipId = `collaborator-tooltip-${collaborator.userId}`;

  return (
    <div
      className={Styles.collaborator}
      data-tooltip-id={tooltipId}
      data-tooltip-place="bottom"
    >
      <UserMarble
        className={Styles.marble}
        email={collaborator.email}
        title={title}
      >
        {marbleContent}
      </UserMarble>
      <Tooltip
        border="1px solid var(--theme-background)"
        className={Styles.tooltip}
        clickable
        id={tooltipId}
        isOpen={title ? false : undefined}
      >
        <UserDetail userDetail={collaborator} />
      </Tooltip>
    </div>
  );
};
